.wrapper {
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
}

.textArea {
	width: 100%;
	background-color: var(--elevation-default);
	border-radius: 6px;
	resize: none;
	border: 1px solid var(--border-primary);
	padding: 8px;
	color: var(--content-primary);
}

.textArea::placeholder {
	color: var(--content-tertiary);
}

.textArea:focus-visible {
	outline: var(--focus-outline);
}

.invalidField .textArea:hover:not(:focus-visible) {
	border: solid 1px var(--border-error);
}

.invalidField .textArea {
	border: solid 1px var(--border-error);
	color: var(--content-error);
}

.invalidField .textArea::placeholder {
	color: var(--content-error);
}

.textArea:hover:not(:focus-visible) {
	border: solid 1px var(--border-hover);
}

.fieldError {
	color: var(--content-error);
}
